import axios from 'axios'
import { alert } from "devextreme/ui/dialog"
const baseUri = "WebApi.asmx/api/RoundService";
const store = {};
const mutations = {
    SET_OPEN_ROUND_LIST(state, posts) {
        state.openRoundList = posts;
        state.openRoundListIsLoading = false;
    },
    GET_DETAIL(state, posts) {
        if (posts.success == true) {
            state.roundDetail = posts.data;
            state.roundDetailChanged = false;
            state.rouImage = state.roundDetail.RouImageUri;
            state.roundDetail.RouImageUri = null;
        }
        else {
            alert(posts.errorMessage);
        }
    },
    SET_ROUND_LIST(state, posts) {
        state.roundList = posts;
        state.roundListIsLoading = false;
    },
    GET_ROUND_SUCHFELD_LIST(state, posts) {
        if (posts.success == true) {
            state.roundSuchfeldList = posts.data;
            state.roundSuchfeldListChanged = false;
        }
        else {
            alert(posts.errorMessage);
        }
    },
    GET_ROUND_GROUP_LIST(state, posts) {
        if (posts.success == true) {
            state.roundGroupList = posts.data;
            state.roundGroupListChanged = false;
        }
        else {
            alert(posts.errorMessage);
        }
    },
    GET_ROUND_TOPICTYPE_LIST(state, posts) {
        if (posts.success == true) {
            state.roundTopicTypeList = posts.data;
            state.roundTopicTypeListChanged = false;
        }
        else {
            alert(posts.errorMessage);
        }
    },
    GET_SUCHFELD_FOR_ROUNDLIST(state, posts) {
        if (posts.success == true) {
            state.suchfeldForRoundList = posts.data;
            state.suchfeldForRoundListChanged = false;
        }
        else {
            alert(posts.errorMessage);
        }
    },
    SAVE_DETAIL(state, posts) {
        if (posts.success == true) {
            state.roundDetailChanged = false;
            state.roundDetail.RouImageUri = null;
        }
        else {
            alert(posts.errorMessage);
        }
    },
    SAVE_ROUND_SUCHFELD_LIST(state, posts) {
        if (posts.success == true) {
            state.roundSuchfeldListChanged = false;
        }
        else {
            alert(posts.errorMessage);
        }
    },
    SAVE_ROUND_GROUP_LIST(state, posts) {
        if (posts.success == true) {
            state.roundGroupListChanged = false;
        }
        else {
            alert(posts.errorMessage);
        }
    },
    SAVE_ROUND_TOPICTYPE_LIST(state, posts) {
        if (posts.success == true) {
            state.roundTopicTypeListChanged = false;
        }
        else {
            alert(posts.errorMessage);
        }
    },
};
const state = {
    openRoundListIsLoading: false,
    openRoundList: [],
    roundListIsLoading: false,
    roundList: [],
    roundDetail: {},
    roundDetailChanged: false,
    roundSuchfeldList: [],
    roundSuchfeldListChanged: false,
    roundGroupList: [],
    roundGroupListChanged: false,
    roundTopicTypeGroupList: [],
    roundTopicTypeListChanged: false,
    suchfeldForRoundList: [],
    suchfeldForRoundListChanged: false,
    rouImage: null,
};
const getters = {};
const actions = {
    getOpenRoundList({ commit }) {
        state.openRoundListIsLoading = true;
        axios
            .get(baseUri + '/GetOpenRoundList')
            .then(res => {
                if (res.data.success == true) {
                    commit('SET_OPEN_ROUND_LIST', res.data.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    getOpenRoundListWithSuchfelder({ commit }) {
        state.openRoundListIsLoading = true;
        axios
            .get(baseUri + '/GetOpenRoundListWithSuchfelder')
            .then(res => {
                if (res.data.success == true) {
                    commit('SET_OPEN_ROUND_LIST', res.data.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    getRoundList({ commit }) {
        state.roundListIsLoading = true;
        axios
            .get(baseUri + '/GetList')
            .then(res => {
                if (res.data.success == true) {
                    commit('SET_ROUND_LIST', res.data.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    getRoundDetail({ commit }, data) {
        state.openRoundListIsLoading = true;
        var formData = new FormData();
        formData.append("rouId", data.rouId);
        axios
            .post(baseUri + '/GetDetail', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_DETAIL', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    getRoundSuchfeldList({ commit }, data) {
        var formData = new FormData();
        formData.append("rouId", data.rouId);
        axios
            .post(baseUri + '/GetRoundSuchfeldList', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_ROUND_SUCHFELD_LIST', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    getRoundGroupList({ commit }, data) {
        var formData = new FormData();
        formData.append("rouId", data.rouId);
        axios
            .post(baseUri + '/GetRoundGroupList', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_ROUND_GROUP_LIST', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    getRoundTopicTypeList({ commit }, data) {
        var formData = new FormData();
        formData.append("rouId", data.rouId);
        axios
            .post(baseUri + '/GetRoundTopicTypeList', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_ROUND_TOPICTYPE_LIST', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    getSuchfeldForRoundList({ commit }, data) {
        var formData = new FormData();
        formData.append("rouId", data.rouId);
        axios
            .post(baseUri + '/GetSuchfeldForRoundList', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_SUCHFELD_FOR_ROUNDLIST', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    saveRoundDetail({ commit }) {
        var formData = new FormData();
        formData.append("data", JSON.stringify(state.roundDetail));
        axios
            .post(baseUri + '/SaveDetail', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('SAVE_DETAIL', res.data);
                } else {
                    alert("An error occured while updating: " + res.data.errorMessage);
                }
            });
    },
    saveRoundSuchfeldList({ commit }) {
        var formData = new FormData();
        formData.append("data", JSON.stringify(state.roundSuchfeldList));
        formData.append("rouId", state.roundDetail.RouId);
        axios
            .post(baseUri + '/SaveRoundSuchfeldList', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('SAVE_ROUND_SUCHFELD_LIST', res.data);
                } else {
                    alert("An error occured while updating: " + res.data.errorMessage);
                }
            });
    },
    saveRoundGroupList({ commit }) {
        var formData = new FormData();
        formData.append("data", JSON.stringify(state.roundGroupList));
        formData.append("rouId", state.roundDetail.RouId);
        axios
            .post(baseUri + '/SaveRoundGroupList', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('SAVE_ROUND_GROUP_LIST', res.data);
                } else {
                    alert("An error occured while updating: " + res.data.errorMessage);
                }
           });
    },
    saveRoundTopicTypeList({ commit }) {
        var formData = new FormData();
        formData.append("data", JSON.stringify(state.roundTopicTypeList));
        formData.append("rouId", state.roundDetail.RouId);
        axios
            .post(baseUri + '/SaveRoundTopicTypeList', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('SAVE_ROUND_TOPICTYPE_LIST', res.data);
                } else {
                    alert("An error occured while updating: " + res.data.errorMessage);
                }
            });
    }
};


export default {
    state,
    store,
    mutations,
    getters,
    actions
}